var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-352.000000, -114.000000)",
    fill: "#F64242"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(352.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,15 C30.9937974,18.7403951 42.9312689,20.6105926 50.8124146,20.6105926 C58.6935603,20.6105926 70.0894221,18.7403951 85,15 C81.7208819,30.5838487 80.0813228,42.5569935 80.0813228,50.9194343 C80.0813228,59.2818751 81.7208819,70.6420637 85,85 C69.4773818,82.3957715 57.4223819,81.0936573 48.8350002,81.0936573 C40.2476185,81.0936573 28.9692851,82.3957715 15,85 C18.0440614,71.6087155 19.566092,60.203654 19.566092,50.7848156 C19.566092,41.3659772 18.0440614,29.4377053 15,15 Z",
    transform: "translate(50.000000, 50.000000) scale(-1, -1) rotate(44.000000) translate(-50.000000, -50.000000)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.3affda761b1cbd73f2abea950021cb4b.svg";
export { ForwardRef as ReactComponent };